import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Job } from '@contracts/interfaces/job.interface';
import { JobService } from 'src/app/services/job.service';
import { is_phone_number_a_mobile, phone_number } from 'src/app/tools/phone-number';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { CustomerService } from '../../services/customer.service';
import { TemplateService } from '../../services/template.service';

@Component({
  selector: 'ap-request-review-dialog',
  templateUrl: 'request-review.dialog.html',
  styleUrls: ['./request-review.dialog.scss']
})
export class RequestReviewDialog {

  body: string = "";
  customer: CustomerInterface;

  hasConfirmed = false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<RequestReviewDialog>,
      public dialog: MatDialog,
      public jobService: JobService,
      public templateService: TemplateService,
      public customerService: CustomerService
      ) {
        this.customer = this.data.customer;

        this.templateService.renderFile("sms-review-request.template.html", this.data).subscribe((response:any)=> {
          this.body = response.render;
        });

      }

    confirm() {
      if (is_phone_number_a_mobile(this.customer.phone)) {
        this.hasConfirmed = true;

        // Prep it for Telnyxs expectations
        let number = "+61" + phone_number(this.customer.phone).substring(1);

        this.jobService.create({
          job: Job.SMS,
          date: {
              start: new Date()        
          },
          data: {
            to: number,
            body: this.body
          }
        }).subscribe((r: any) => {
          if (this.customer.googleReviewSMS == undefined) {
            this.customer.googleReviewSMS = [];
          }

          this.customer.googleReviewSMS.push(new Date());

          console.log(this.customer)
          this.customerService.updateOne(this.customer).subscribe(r => {
            this.dialogRef.close(r);
          });
        })
      }
    }
}
